/* Finish the cart's free-delivery bar in the visitor's currency. The threshold
   is set in the shop currency; Shopify's published rate converts it, rounded up
   to a whole unit, matching the announcement bar. Re-runs whenever the cart
   drawer is refreshed. */
(function () {
  const draw = () => {
    document.querySelectorAll('[data-ship-bar]').forEach((bar) => {
      const cur = window.Shopify && Shopify.currency;
      const rate = cur && cur.rate ? parseFloat(cur.rate) : 1;
      const code = bar.dataset.currency || (cur && cur.active) || 'GBP';
      const fixed = parseFloat(bar.dataset.fixedAmount);
      const threshold = (bar.dataset.fixedCurrency === code && fixed > 0)
        ? Math.round(fixed * 100)
        : Math.ceil((parseInt(bar.dataset.thresholdMinor, 10) / 100) * rate) * 100;
      const total = parseInt(bar.dataset.total, 10) || 0;
      const remaining = threshold - total;
      const msg = bar.querySelector('[data-ship-message]');
      const fill = bar.querySelector('[data-ship-fill]');
      // whole units only: "Spend €13 more", never "Spend €0,05 more"
      const fmt = (minor) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: code, maximumFractionDigits: 0 }).format(Math.ceil(minor / 100));
      if (remaining > 0) {
        msg.textContent = bar.dataset.progressText.replace('[amount]', fmt(remaining));
        bar.classList.remove('is-done');
      } else {
        msg.textContent = bar.dataset.reachedText;
        bar.classList.add('is-done');
      }
      if (fill) fill.style.width = Math.min(100, Math.round((total / threshold) * 100)) + '%';
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', draw) : draw();
  document.addEventListener('cart:updated', () => setTimeout(draw, 0));
  // the drawer's contents are replaced after a change; draw again once they land
  if ('MutationObserver' in window) {
    new MutationObserver(() => { if (document.querySelector('[data-ship-bar] [data-ship-message]:empty')) draw(); })
      .observe(document.body, { childList: true, subtree: true });
  }
})();
